import { FunctionComponent, ComponentChild } from 'preact';
import { useCallback, useState } from 'preact/hooks';
import cn from 'classnames';

interface AssetThumbnailProps {
  imageSrc?: string;
  label?: ComponentChild;
  primaryBadge?: ComponentChild;
  secondaryBadge?: ComponentChild;
  tertiaryBadge?: ComponentChild;
}

export const AssetThumbnail: FunctionComponent<AssetThumbnailProps> = ({
  imageSrc = '',
  primaryBadge,
  secondaryBadge,
  tertiaryBadge,
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleImageLoad = useCallback(() => {
    setIsImageLoaded(true);
  }, []);

  const displayTopOverlay = Boolean(tertiaryBadge);
  const displayBottomOverlay = Boolean(primaryBadge) || Boolean(secondaryBadge);

  return (
    <div
      className={cn('vgp-thumbnail', {
        'vgp-thumbnail-loaded': isImageLoaded,
        'vgp-thumbnail-has-top-overlay': displayTopOverlay,
        'vgp-thumbnail-has-bottom-overlay': displayBottomOverlay,
      })}
    >
      <div
        className="vgp-thumbnail-aspect-ratio"
        style={{ backgroundImage: `url("${imageSrc}")` }}
      >
        <img
          loading="lazy"
          src={imageSrc}
          draggable={false}
          alt="thumbnail"
          onLoad={handleImageLoad}
          className="vgp-thumbnail-image"
        />
      </div>
      {displayTopOverlay && (
        <div className="vgp-thumbnail-top-overlay">
          {tertiaryBadge && (
            <div className="vgp-thumbnail-badge-tertiary">{tertiaryBadge}</div>
          )}
        </div>
      )}
      {displayBottomOverlay && (
        <div className="vgp-thumbnail-bottom-overlay">
          {secondaryBadge && (
            <div className="vgp-thumbnail-badge-secondary">
              {secondaryBadge}
            </div>
          )}
          {primaryBadge && (
            <div className="vgp-thumbnail-badge-primary">{primaryBadge}</div>
          )}
        </div>
      )}
    </div>
  );
};
